import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../../../..";
import { CustomAction } from "../../../../store/customAction";
import {IGetAddLienholderFormFieldsResponse } from "../../../../models/user/Lienholder/Lienholder";
import { API_GET_ADD_LIENHOLDER_FORM_FIELDS_JSON, API_POLICY_CHANGE } from "../../../../Apis/ApiEndPoints";
import { ILienholderPolicyChangeRequestParams, IPolicyChangeResponse } from "../../../../models/user/PolicyChange/PolicyChange";

export const GetAddLienholderFormJson = createAsyncThunk(
  "driver/GetAddLienholderFormJson",
  async (_, { dispatch }) => {
    const response: IGetAddLienholderFormFieldsResponse = await CustomAction(
      Api.get(API_GET_ADD_LIENHOLDER_FORM_FIELDS_JSON),
      dispatch,
      "driver/GetAddLienholderFormJson"
    );
    return response;
  }
);


export const AddVehicleFinanceCompany = createAsyncThunk(
  "policyChange/AddVehicleFinanceCompany",
  async (requestParams: ILienholderPolicyChangeRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/addVehicleFinanceCompany`, requestParams),
      dispatch,
      "policyChange/AddVehicleFinanceCompany"
    );
    return response;
  }
);
